import React, { useEffect, useState } from "react";
import { SlideBar } from "./SliderBar";
import { Header } from "./Header";
import useMobileDetect from "./IsMobile";
import { useLocation } from "react-router-dom";

function MergeComponents(props) {
    const isMobile = useMobileDetect();
    const location = useLocation();
    const [getActiveClass, setGetActiveClass] = useState(true);
    useEffect(() => {
        if (isMobile) {
            setGetActiveClass(false);
        }
    }, [location, isMobile]);

    useEffect(() => {
        if (!isMobile) setGetActiveClass(true);
    }, [isMobile]);

    const handleActiveClass = () => {
        setGetActiveClass(!getActiveClass)
    }

    return (
        <>
            <div className="merge">
                <div className="mainLite">
                    <SlideBar activeClass={getActiveClass} onToggle={() => { isMobile && setGetActiveClass(!getActiveClass) }} />
                </div>
                <div className="contant">
                    <Header getActiveClass={handleActiveClass} />
                    {props.getComponent}
                </div>
            </div>
        </>
    )
}
export { MergeComponents }